import keycloakService from '../../keycloak_service';

import { sinatraOrigin } from '../../config';

const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then(response => response.json())

export const fetchModelVersionStorageSize = (queryParams) => {
  const [, model_versions] = queryParams;
  const body = JSON.stringify({ model_versions, confirm_delete: false });

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body
  };

  return postToApi('v1/api/models/delete_model_versions', fetchOptions)
}

export const removeModelVersions = (model_versions) => {
  const body = JSON.stringify({ model_versions, confirm_delete: true })

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body
  };

  return postToApi('v1/api/models/delete_model_versions', fetchOptions)
}

export default removeModelVersions;
